import styled, {css} from 'styled-components';
import {Button, Drawer, Space} from 'antd';
import {typographyStyles} from '../../utils/styles';

const bubbleStyles = css`
  background-color: transparent;
  padding: 8px;
  border-radius: 8px;
  box-shadow: 0 1px 4px 0 #00000040;
  color: ${props => props.theme.colors.neutral_10};
  font-size: 14px;
  line-height: 22px;
  min-height: unset;
`;

const StyledAgentChatDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 0;
  }
`;

const StyledAgentChat = styled.div`
  display: flex;
  flex-direction: column;

  .ant-bubble {
    padding: 0 5px;

    &.bubble-file-message,
    &.bubble-error-message,
    &.bubble-confirmation-message,
    &.bubble-options-message {
      .ant-bubble-content {
        background-color: transparent;
        min-height: unset;
        padding: 0;
      }
    }

    &.bubble-confirmation-message,
    &.bubble-options-message {
      .ant-bubble-content {
        width: 100%;
      }
    }

    .ant-bubble-content-filled {
      background-color: transparent;
    }

    .ant-attachment-list-card-type-overview {
      border-radius: 8px;
    }

    &:not(.bubble-file-message):not(.bubble-error-message):not(.bubble-confirmation-message):not(.bubble-options-message) {

      .ant-bubble-content {
        ${bubbleStyles};
      }
    }

    &[role='user']:not(.bubble-file-message):not(.bubble-error-message):not(.bubble-confirmation-message):not(.bubble-options-message) {
      .ant-bubble-content {
        background-color: ${props => props.theme.colors.primary_1};
      }
    }

    &[role='assistant']:not(.bubble-file-message):not(.bubble-error-message):not(.bubble-confirmation-message):not(.bubble-options-message) {
      .ant-bubble-content {
        background-color: #EBE8FE;
      }
    }
  }

  .ant-bubble-content {
    min-height: unset;
    p {
      margin: 0;
    }
  }

  .ant-bubble-list {
    padding: 5px 0;
    width: 100%;
  }

`;

const StyledAgentChatWaitingSpace = styled(Space)`
  align-items: center;
  color: ${props => props.theme.colors.neutral_7};
  display: flex;

  .ant-spin-dot {
    display: flex;
    align-items: center;
    justify-content: center;
    div {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    svg {
      height: 24px !important;
      width: 24px !important;
      transform: unset !important;
    }
  }

  ${props => props.type === 'small' && `
    ${typographyStyles.footnote.description};

    .ant-spin-dot {
      svg {
        height: 16px;
        width: 16px;
      }
    }
  `}
`;


const StyledAgentChatWaitingSpaceContainer = styled.div`
  min-height: 22px;

  ${StyledAgentChatWaitingSpace} {
    padding: 0 5px;
  }
`;

const StyledAgentChatBody = styled(Space)`
  padding: 24px 19px;
  width: 100%;
  height: calc(100vh - 143px - 57px);
  overflow-y: auto;

  & > .ant-space-item {
    width: 100%;
  }
`;

const StyledAgentChatBodyWelcome = styled(Space)`
  padding: 0 5px;
`;

const StyledAgentChatBodyWelcomeTitle = styled.div`
  ${typographyStyles.heading.h3};

  .ant-space-item {
    display: flex;
  }

  svg {
    height: 32px;
    width: 32px;

    path {
      stroke: ${props => props.theme.colors.additional_purple};
    }
  }
`;

const StyledAgentChatFooter = styled(Space)`
  border-top: 1px solid ${props => props.theme.colors.neutral_3};
  padding: 24px;
  width: 100%;
  position: absolute;
  bottom: 0;

  .ant-sender:focus-within {
    border-color: ${props => props.theme.colors.additional_purple};
    &:after {
      border-width: 1px;
    }
  }
  .ant-sender-content,
  .ant-sender-footer {
    padding-inline-start: 12px;
  }
`;

const StyledAgentChatConfirmation = styled.div`
  svg {
    margin-right: 8px;
    width: 16px;
    height: 16px;
  }

  & > p {
    ${bubbleStyles};
    background-color: #EBE8FE;
    margin-bottom: 0;
    max-width: 100%;
    width: max-content;
    &:has(+ div) {
      margin-bottom: 16px !important;
    }
  }
`;

const StyledAgentChatOptionButton = styled(Button)`
  margin: auto;
  width: max-content;

  &.ant-btn-variant-link {
    ${typographyStyles.body.regular};
    color: ${props => props.theme.colors.additional_purple};
  }
`;

const StyledAgentChatConfirmationOption = styled.div`
  align-items: center;
  border: 1px solid;
  border-radius: 4px;
  display: flex;
  font-size: 14px;
  padding: 6px 12px;
  width: 100%;

  .ant-space-item {
    display: flex;
  }

  ${props => (props.variant === 'confirm' || props.variant === 'option') && css`
    border-color: ${props => props.theme.colors.additional_purple};

    svg {
      path {
        fill: ${props => props.theme.colors.additional_purple};
      }
    }
  `}

  ${props => props.variant === 'cancel' && css`
    border-color: ${props => props.theme.colors.functional_danger_d};

    svg {
      path {
        fill: ${props => props.theme.colors.functional_danger_d};
      }
    }
  `}

  &:hover {
    cursor: pointer;
  }
`;

export {
  StyledAgentChat,
  StyledAgentChatWaitingSpaceContainer,
  StyledAgentChatWaitingSpace,
  StyledAgentChatBody,
  StyledAgentChatBodyWelcome,
  StyledAgentChatBodyWelcomeTitle,
  StyledAgentChatConfirmation,
  StyledAgentChatConfirmationOption,
  StyledAgentChatDrawer,
  StyledAgentChatFooter,
  StyledAgentChatOptionButton,
}
